<template>
</template>

<script>
	export default {
		data (){
			return {
				token:"",
			}
		},
		methods:{
			
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PortraitForEquipment.vue?72adc828